import { localDB } from '../db/pouchdb-config';
import bcrypt from 'bcryptjs';

/**
 * Utility function to migrate existing plain text passwords to bcrypt hashed passwords
 * This should be run once to update all existing users in the database
 */
export const migratePasswords = async () => {
  try {
    console.log('Starting password migration...');
    
    // Get all users
    const result = await localDB.find({
      selector: {
        type: 'customer'
      }
    });
    
    const users = result.docs;
    console.log(`Found ${users.length} users to migrate`);
    
    // Process each user
    for (const user of users) {
      // Skip users that might already have bcrypt hashes
      if (user.password && !user.password.startsWith('$2a$') && !user.password.startsWith('$2b$')) {
        console.log(`Migrating password for user: ${user.email}`);
        
        // Hash the plain text password
        const salt = await bcrypt.genSalt(10);
        const hashedPassword = await bcrypt.hash(user.password, salt);
        
        // Update the user document
        user.password = hashedPassword;
        await localDB.put(user);
        
        console.log(`Successfully migrated password for user: ${user.email}`);
      } else {
        console.log(`Skipping user ${user.email} - password already appears to be hashed`);
      }
    }
    
    console.log('Password migration completed successfully');
    return { success: true, migratedCount: users.length };
  } catch (error) {
    console.error('Error during password migration:', error);
    return { success: false, error: error.message };
  }
};

const passwordMigration = { migratePasswords };

export default passwordMigration;